<template>
    <v-app class="ll-root">
        <v-container fluid class="ll-container">
            <div class="ll-wave">
                <!-- Creating a SVG image -->
                <svg
                    viewBox="0 70 500 500"
                    preserveAspectRatio="xMinYMin meet"
                    transform="scale(-1 1)"
                >
                    <defs>
                        <linearGradient
                            id="grad1"
                            x1="0%"
                            y1="0%"
                            x2="0%"
                            y2="100%"
                        >
                            <stop
                                offset="50%"
                                style="stop-color:rgb(0,62,82);stop-opacity:1"
                            />
                            <stop
                                offset="100%"
                                style="stop-color:rgb(33,33,33);stop-opacity:1"
                            />
                        </linearGradient>
                    </defs>
                    <path
                        d="M0, 200 C250, 300 300,
                0 600, 200 L600, 00 L0, 0 Z"
                        style="stroke:none;"
                        fill="url(#grad1)"
                    ></path>
                </svg>
            </div>
            <v-row class="m-3">
                <v-col cols="3">
                    <div class="logo">
                        <a href="/">
                            <v-img
                                max-height="50"
                                max-width="150"
                                src="/media/photos/logo@2x.png"
                            />
                        </a>
                    </div>
                </v-col>
                <v-spacer />
                <v-col cols="3" class="text-right">
                    <span
                        style="color: #fff"
                        class="font-weight-bold white--text"
                        >{{ displayMode[mode].text }}</span
                    >
                    <v-btn
                        outlined
                        rounded
                        dark
                        class="ml-3 font-weight-bold"
                        :href="displayMode[mode].link"
                        >{{ displayMode[mode].btnText }}</v-btn
                    >
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    align-self="center"
                    class="d-flex flex-column justify-center"
                    style="min-height: 80vh"
                >
                    <slot />
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
export default {
    name: 'LimboLayout',
    props: {
        mode: {
            required: false,
            type: String,
            default: 'create'
        }
    },
    data() {
        return {
            displayMode: {
                login: {
                    text: 'Already have an account?',
                    link: window.location.origin + '/login',
                    btnText: 'Login'
                },
                create: {
                    text: "Don't have an account?",
                    link: '#',
                    btnText: 'Create Account'
                }
            }
        };
    }
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';
.ll {
    &-root {
        min-height: 100vh;
        background-color: #e4ebed;
    }
    &-container {
        min-height: 100vh;
        background: #e4ebed; // $bw-blue-grey-gradient-vertical;
    }
    &-wave {
        // transform: rotate3d(1, 0, 0, 180deg);
        max-height: 100vh;
        width: 100%;
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        overflow: hidden;
    }
}
</style>
